import React from 'react';
import { Check, X } from 'lucide-react';
import { motion } from 'framer-motion';
export function DifferentiationSection() {
  return <section className="py-24 bg-gradient-to-br from-[#F0FFF4] to-white" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-20">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-21">
            <span className="text-[#10B981] font-bold uppercase tracking-wider text-sm" data-id="element-22">
              Why Choose Us
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1B5E20] mb-8 mt-2" data-id="element-23">
              5 Reasons Why Thousands Choose{' '}
              <span className="text-[#10B981]" data-id="element-24">LymphoriaX</span>
            </h2>
            <ul className="space-y-6" data-id="element-25">
              {['Supports healthy lymphatic flow with proven botanicals', 'Pure, plant-based formula with no artificial ingredients', 'Gentle daily detox that works with your body', 'Third-party tested for purity and potency', 'Real, noticeable changes you can see and feel'].map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="flex items-center space-x-4" data-id="element-26">
                  <div className="w-8 h-8 rounded-full bg-[#10B981] flex items-center justify-center flex-shrink-0 shadow-lg" data-id="element-27">
                    <Check className="w-5 h-5 text-white" data-id="element-28" />
                  </div>
                  <span className="text-lg text-[#1B5E20] font-medium" data-id="element-29">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl p-8 shadow-xl border-2 border-[#10B981]/20" data-id="element-30">
            <h3 className="text-2xl font-bold text-[#1B5E20] mb-8 text-center" data-id="element-31">
              How We Compare
            </h3>
            <div className="space-y-4" data-id="element-32">
              {[{
              label: 'Clean herbal ingredients',
              us: true,
              them: false
            }, {
              label: 'No added sugar',
              us: true,
              them: false
            }, {
              label: 'Gentle detox support',
              us: true,
              them: true
            }, {
              label: 'Third-party tested',
              us: true,
              them: false
            }, {
              label: 'Visible results',
              us: true,
              them: false
            }, {
              label: '60-day guarantee',
              us: true,
              them: false
            }, {
              label: 'Made in USA',
              us: true,
              them: false
            }, {
              label: '12,847+ reviews',
              us: true,
              them: false
            }].map((row, i) => <div key={i} className="grid grid-cols-3 items-center py-3 border-b border-gray-200 last:border-0" data-id="element-33">
                  <div className="text-sm font-medium text-[#374151]" data-id="element-34">
                    {row.label}
                  </div>
                  <div className="flex justify-center" data-id="element-35">
                    {row.us ? <div className="bg-[#10B981] rounded-full p-1" data-id="element-36">
                        <Check className="w-5 h-5 text-white" data-id="element-37" />
                      </div> : <X className="w-6 h-6 text-gray-300" data-id="element-38" />}
                  </div>
                  <div className="flex justify-center" data-id="element-39">
                    {row.them ? <Check className="w-6 h-6 text-gray-400" data-id="element-40" /> : <X className="w-6 h-6 text-gray-300" data-id="element-41" />}
                  </div>
                </div>)}

              <div className="grid grid-cols-3 pt-4 text-center text-xs font-bold uppercase tracking-wider" data-id="element-42">
                <div data-id="element-43"></div>
                <div className="text-[#10B981]" data-id="element-44">LymphoriaX</div>
                <div className="text-gray-400" data-id="element-45">Others</div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}